module.exports = __webpack_public_path__ + "img/bez_hypoteky_v1.680874cd.svg";